import { render } from "./UserEditPublisherAssignment.vue?vue&type=template&id=fb6eca5a&scoped=true"
import script from "./UserEditPublisherAssignment.vue?vue&type=script&lang=js"
export * from "./UserEditPublisherAssignment.vue?vue&type=script&lang=js"

import "./UserEditPublisherAssignment.vue?vue&type=style&index=0&id=fb6eca5a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb6eca5a"]])

export default __exports__